/* ===========================================================================
   OB USP band - static when the four items fit, a left-to-right marquee when
   they do not. Layout and motion are in assets/ob-usp.css; this only decides
   which, and writes the period.

   MEASURED, NOT ASSUMED FROM A BREAKPOINT: the copy differs per arm and the
   type differs per template, so whether the row fits is read off the page.
   Re-measured on resize and once the web font has landed (the font changes
   the widths). The motion only STARTS after the font, so the period it runs on
   is the real one and never jumps.
   =========================================================================== */
(function () {
  'use strict';

  var SPEED = 40; /* px per second - inside the 35-45 brief */

  function init(band) {
    if (band.__obUsp) { return; }
    band.__obUsp = true;

    var vp = band.querySelector('[data-ob-usp-viewport]');
    var set = band.querySelector('[data-ob-usp-set]');
    var track = band.querySelector('[data-ob-usp-track]');
    if (!vp || !set || !track) { return; }

    var fontReady = false;
    var lastW = -1;

    function measure() {
      band.classList.add('is-measuring');
      var natural = set.getBoundingClientRect().width;
      band.classList.remove('is-measuring');

      var marquee = natural > vp.clientWidth + 0.5;
      band.classList.toggle('is-marquee', marquee);

      if (!marquee) {
        band.classList.remove('is-running');
        lastW = -1;
        return;
      }
      /* the period: one set including its trailing gap */
      var w = set.getBoundingClientRect().width;
      if (Math.abs(w - lastW) > 0.5) {
        lastW = w;
        track.style.setProperty('--ob-usp-w', w + 'px');
        track.style.setProperty('--ob-usp-dur', (w / SPEED).toFixed(2) + 's');
      }
      if (fontReady) { band.classList.add('is-running'); }
    }

    var queued = false;
    function queue() {
      if (queued) { return; }
      queued = true;
      requestAnimationFrame(function () { queued = false; measure(); });
    }

    measure();

    if ('ResizeObserver' in window) {
      new ResizeObserver(queue).observe(vp);
    } else {
      window.addEventListener('resize', queue);
    }

    function onFont() {
      if (fontReady) { return; }
      fontReady = true;
      measure();
    }
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(onFont);
    }
    setTimeout(onFont, 3000); /* never wait longer than this to start */

    /* touch: hold still while a finger is on the band */
    vp.addEventListener('touchstart', function () { band.classList.add('is-paused'); }, { passive: true });
    function release() { band.classList.remove('is-paused'); }
    vp.addEventListener('touchend', release, { passive: true });
    vp.addEventListener('touchcancel', release, { passive: true });
  }

  function boot(root) {
    var bands = (root || document).querySelectorAll('[data-ob-usp]');
    for (var i = 0; i < bands.length; i++) { init(bands[i]); }
  }

  boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
}());
